import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { userKeys } from '@/shared/lib/query/queryKeys';

import { fetchTeamOwners, fetchUserOwners } from '@/entities/owner/api';
import type { TeamOwner, UserOwner } from '@/entities/owner/domain/types';

export const useTeamOwners = () => {
  return useQueryWithBoundary<TeamOwner[]>({
    queryKey: userKeys.teamOwners(),
    queryFn: fetchTeamOwners,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};

export const useUserOwners = () => {
  return useQueryWithBoundary<UserOwner[]>({
    queryKey: userKeys.userOwners(),
    queryFn: fetchUserOwners,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
